// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WxcX","content":"styles_content__10qN1"};